// NOTE: Copied from AC
import React from 'react';
import { Link } from 'react-router-dom';

type BuildMessageProps = {
  response: any;
  isDestinationTrial?: boolean;
  isDestinationFreeEdition?: boolean;
};

enum OrderTransitionType {
  SCHEDULED = 'SCHEDULED',
  IMMEDIATE = 'IMMEDIATE',
}

export const buildMessage = ({
  response,
  isDestinationTrial = false,
  isDestinationFreeEdition = false,
}: BuildMessageProps) => {
  switch (true) {
    case response?.transitionTime === OrderTransitionType.IMMEDIATE && isDestinationTrial && !isDestinationFreeEdition:
      return {
        header: 'Subscription changes submitted',
        message: (
          <div>
            <p>You can view the changes in the order history tab.</p>
            <Link to={`#order-history`}>View order history</Link>
          </div>
        ),
      };
    case response?.transitionTime === OrderTransitionType.SCHEDULED:
      return {
        header: 'Subscription changes pending',
        message: (
          <>
            <p>This change will take place on the next bill date.</p>
            <Link to={'#scheduled-changes'}>View scheduled changes</Link>
          </>
        ),
      };
    default:
      return {
        header: 'Subscription changes submitted',
        message: (
          <div>
            <p>
              A new invoice is being generated for applicable subscription changes and will be available in 24 hours.
              You can view the changes in the &nbsp;<strong>order history</strong>&nbsp; tab.
            </p>
            <Link to={`#order-history`}>View order history</Link>
          </div>
        ),
      };
  }
};
